// 组合式api设计store
import { defineStore } from "pinia";
import { ref, computed } from "vue";
import AES from "@/utils/aes";

export const useSystemConfigStore = defineStore(
  "systemConfigStore",
  () => {
    /*************** base config ***************/
    const baseConfig = ref("");
    function setBaseConfig(data = "") {
      baseConfig.value = data;
    }
    const getBaseConfig = computed(() => {
      if (baseConfig.value) {
        return JSON.parse(AES.decrypt(baseConfig.value, "6plwu888B@M1x917"));
      } else {
        return "";
      }
    });
    /*************** base config ***************/

    /*************** loading配置 **************/
    const loadingCount = ref(0);
    const isLoading = computed(() => {
      return loadingCount.value > 0;
    });
    function addLoading() {
      loadingCount.value++;
    }
    function removeLoading() {
      loadingCount.value && loadingCount.value--;
    }
    /*************** loading配置 **************/

    return {
      getBaseConfig,
      setBaseConfig,
      isLoading,
      addLoading,
      removeLoading,
      baseConfig,
    };
  },
  {
    persist: {
      key: "ltw-systemConfigStore",
      storage: localStorage,
      pick: ["baseConfig"],
    },
  }
);
